import { render, staticRenderFns } from "./TransferAccountList.vue?vue&type=template&id=56af519d&"
import script from "./TransferAccountList.vue?vue&type=script&lang=js&"
export * from "./TransferAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports